 <!-- Hide Flits Reward button from Skin Analyzer Page. -->
 // Check if the current page is the specific page
        if (window.location.pathname === "/pages/skin-analyzer") {
          // Create a MutationObserver to monitor DOM changes
           observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === "childList") {
                var rewardIcon = document.querySelector(".flits-reward-button.undefined");
                if (rewardIcon) {
                  rewardIcon.style.display = "none"; // Hide the reward icon
                  observer.disconnect(); // Stop observing after hiding the icon
                }
              }
            });
          });
      
          // Start observing the body for child additions
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
 }